import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration } from 'chart.js';
import { SpendIntelligenceComponent } from '../spend-intelligence/spend-intelligence.component';
import { ChartPalette, ChartPaletteService, withAlpha } from 'src/app/Services/chart-palette.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-spend-analytics',
  standalone: true,
  imports: [CommonModule, BaseChartDirective, SpendIntelligenceComponent, TranslateModule],
  templateUrl: './spend-analytics.component.html',
  styleUrl: './spend-analytics.component.scss',
})
export class SpendAnalyticsComponent implements OnDestroy {
  private paletteSub: Subscription;

  constructor(private palette: ChartPaletteService) {
    // Synchronous BehaviorSubject — populates chart config before first render
    // and re-runs on every theme switch.
    this.paletteSub = this.palette.palette$.subscribe((p) => this.applyPalette(p));
  }

  ngOnDestroy(): void {
    this.paletteSub?.unsubscribe();
  }

  selectedTab: 'analytics' | 'intelligence' = 'analytics';

  selectTab(tab: 'analytics' | 'intelligence') {
    this.selectedTab = tab;
  }

  /** Line chart for "Spend Trends Over Time". Built by `applyPalette`. */
  spendTrendsData!: ChartConfiguration<'line'>['data'];

  /** Rebuilds the line chart's color slots from the active theme. */
  private applyPalette(p: ChartPalette): void {
    this.spendTrendsData = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
      datasets: [
        {
          label: 'Total Spend',
          data: [220, 260, 240, 280, 310, 330],
          borderColor: p.accent,
          backgroundColor: withAlpha(p.accent, 0.12),
          tension: 0.4,
          fill: true,
          pointRadius: 4,
          pointBackgroundColor: p.accent,
        },
        {
          label: 'Budget',
          data: [210, 230, 245, 260, 275, 290],
          borderColor: p.axisMuted,
          backgroundColor: withAlpha(p.axisMuted, 0.08),
          borderDash: [6, 4],
          tension: 0.4,
          fill: false,
          pointRadius: 0,
        },
      ],
    };
  }

  spendTrendsOptions: ChartConfiguration<'line'>['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          usePointStyle: true,
        },
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => `$${value}k`,
        },
      },
    },
    interaction: {
      mode: 'index',
      intersect: false,
    },
  };
}

